import styled from "styled-components";
import {
  Avatar as AntAvatar,
  Badge as AntBadge,
  Input as AntInput,
} from "antd";

export const Space = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 32px;
`;

export const Avatar = styled(AntAvatar)`
  border: 2px solid #71207c;
`;

export const Badge = styled(AntBadge)`
  .ant-badge-count {
    height: auto;
    width: 80px;
    border-radius: 5px;
    box-shadow: none;
    background: linear-gradient(180deg, #fff987, #d69c17);
    font-size: 11px;
    font-weight: normal;
    color: #670000;
    margin-top: 36px;
    margin-bottom: 32px;
  }
`;

export const InputLabel = styled.p`
  font-size: 16px;
  margin: 0px;
  padding: 0px;
`;

export const Input = styled(AntInput)`
  margin-top: 16px;
  margin-bottom: 32px;
  border: 1px solid #e1cce0;
  text-align: center;
  :placeholder: {
    text-align: center;
  }
`;

export const FileInput = styled.input`
  display: none;
`;